import { GatewayId } from '../../../types/third-party-system.enums';
import {
    IpgSystemId,
    IpgSystemIdKey,
    ThirdPartySystemId,
    type SupportedIpgSystemId,
} from '../../third-party-system.enums';

export const CloverIpgSystemId = IpgSystemId.CLOVER;
export const CloverIpgSystemIdKey = IpgSystemIdKey.CLOVER;
export const CloverThirdPartySystemId = ThirdPartySystemId.CLOVER;
export const CloverGatewayId = GatewayId.CLOVER;

export function isCloverIpgSystemId(
    systemId: IpgSystemId
): systemId is SupportedIpgSystemId {
    return systemId === CloverIpgSystemId;
}

export function isCloverThirdPartySystemId(
    systemId: ThirdPartySystemId
): systemId is typeof CloverThirdPartySystemId {
    return systemId === CloverThirdPartySystemId;
}
